"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCreditCard = void 0;
var React = __importStar(require("react"));
var IconCreditCard = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("title", null, "Carte Bleue"),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "credit-card-a", x1: "18.195%", x2: "81.195%", y1: "76.094%", y2: "23.42%" },
            React.createElement("stop", { offset: "0%", stopColor: "#009B4B" }),
            React.createElement("stop", { offset: "34.376%", stopColor: "#0091A1" }),
            React.createElement("stop", { offset: "68.595%", stopColor: "#006298" }),
            React.createElement("stop", { offset: "100%", stopColor: "#002756" }))),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("rect", { width: 24, height: 24 }),
        React.createElement("g", { fillRule: "nonzero", transform: "translate(2.5 6)" },
            React.createElement("rect", { width: 19, height: 12, fill: "url(#credit-card-a)", rx: 1 }),
            React.createElement("path", { fill: "#FFF", d: "M14.5,6.2 C15.3284271,6.2 16,6.87157288 16,7.7 C16,8.52842712 15.3284271,9.2 14.5,9.2 L10,9.2 L10,6.2 L14.5,6.2 Z M6.5,3 C8.09631271,3 9.40142392,4.24678186 9.49467022,5.81968218 L5.5,5.82 L5.5,6.18 L9.49467022,6.18031782 C9.40142392,7.75321814 8.09631271,9 6.5,9 L5.5,9 C3.84314575,9 2.5,7.65685425 2.5,6 C2.5,4.34314575 3.84314575,3 5.5,3 L6.5,3 Z M14.5,2.9 C15.3284271,2.9 16,3.57157288 16,4.4 C16,5.22842712 15.3284271,5.9 14.5,5.9 L10,5.9 L10,2.9 L14.5,2.9 Z" }))))); };
exports.IconCreditCard = IconCreditCard;
exports.IconCreditCard.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconCreditCard;
